module.exports = __webpack_public_path__ + "static/media/VV 13.95957904.mp3";